<template>
  <div class="user-list">
    <v-data-table
      :headers="headers"
      :items="adminUserSearchResults"
      sort-by="id"
      :loading="tableLoader"
      :search="search"
      loading-text="Fetching Users..."
      class="mb-12 elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Users</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.emailAddress="{ item }">
        <router-link :to="`/user/${item.id}`">
          {{ item.emailAddress }}
        </router-link>
      </template>

      <template v-slot:item.walletBalance="{ item }">
        {{ item.walletBalance | numberToMoney }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'UserList',

    computed: {
      ...mapGetters([
        'adminUserSearchResults'
      ])
    },

    data: () => ({
      tableLoader: true,

      search: '',

      // Mapping datatable.
      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'start'
        },
        {
          text: 'Email',
          value: 'emailAddress',
          sortable: true
        },
        {
          text: 'Name',
          value: 'fullName',
          sortable: true
        },
        {
          text: 'Is Admin',
          value: 'admin',
          sortable: true
        },
        {
          text: 'Wallet Balance',
          value: 'walletBalance',
          align: 'end',
          sortable: true
        }
      ]
    }),

    methods: {
      ...mapActions([
        'userSearch'
      ])
    },

    created() {
      this.userSearch().then(() => {
        this.tableLoader = false
      })
    }
  }
</script>
